export const PUBLICATION_CODES = {
  NONE: 'NONE', // Null value for publication code
  SUNWEB_NL_SUMMER: 'SZ',
  SUNWEB_FR_SUMMER: 'FZ',
  SUNWEB_DK_SUMMER: 'KZ',
  SUNWEB_SE_SUMMER: 'QZ',
  SUNWEB_BE_NL_SUMMER: 'BZ',
  SUNWEB_BE_FR_SUMMER: 'FS',
  SUNWEB_NL_WINTER: 'WG',
  SUNWEB_DE_WINTER: 'DW',
  SUNWEB_FR_WINTER: 'FW',
  SUNWEB_DK_WINTER: 'KW',
  SUNWEB_UK_WINTER: 'UW',
  SUNWEB_SE_WINTER: 'QW',
  SUNWEB_BE_NL_WINTER: 'BW',
  SUNWEB_BE_FR_WINTER: 'FH',
  ELIZA_NL: 'EZ',
  ELIZA_BE: 'BE',
  ELIZA_UK: 'UE',
  GOGO_NL: 'JR',
} as const

export const SUNWEB_PUBLICATION_CODES = {
  summer: [
    PUBLICATION_CODES.SUNWEB_NL_SUMMER,
    PUBLICATION_CODES.SUNWEB_FR_SUMMER,
    PUBLICATION_CODES.SUNWEB_DK_SUMMER,
    PUBLICATION_CODES.SUNWEB_SE_SUMMER,
    PUBLICATION_CODES.SUNWEB_BE_NL_SUMMER,
    PUBLICATION_CODES.SUNWEB_BE_FR_SUMMER,
  ] as const,
  winter: [
    PUBLICATION_CODES.SUNWEB_NL_WINTER,
    PUBLICATION_CODES.SUNWEB_DE_WINTER,
    PUBLICATION_CODES.SUNWEB_FR_WINTER,
    PUBLICATION_CODES.SUNWEB_DK_WINTER,
    PUBLICATION_CODES.SUNWEB_UK_WINTER,
    PUBLICATION_CODES.SUNWEB_SE_WINTER,
    PUBLICATION_CODES.SUNWEB_BE_NL_WINTER,
    PUBLICATION_CODES.SUNWEB_BE_FR_WINTER,
  ] as const,
} as const

export const ELIZA_PUBLICATION_CODES = [
  PUBLICATION_CODES.ELIZA_NL,
  PUBLICATION_CODES.ELIZA_BE,
  PUBLICATION_CODES.ELIZA_UK,
] as const

export const WINTER_ONLY_PUBLICATION_CODES = [
  PUBLICATION_CODES.SUNWEB_DE_WINTER,
  PUBLICATION_CODES.SUNWEB_UK_WINTER,
] as const
